export default __webpack_public_path__ + "static/media/dropDownOpenIcon.cb11bc62.svg";